import React, { Component } from "react";
import {
    Row,
    Col,
    Form,
    Space,
    Button,
    Select,
    Input,
    Table,
    Tooltip,
} from "antd";
import { Link } from "react-router-dom";
import withRouter from "../withRouter";
import { StoreContext } from "../store/RootStore";
import { observer } from "mobx-react";

import AssignDriverToUserStore from "../store/AssignDriverToUserStore";
import UsersStore from "../store/UsersStore";
import { DeleteFilled } from "@ant-design/icons";
import config from "../config"
import DriversStore from "../store/DriversStore";

class AssignDriverToUser extends Component {
    constructor(props) {
        super(props);
        // this.handleChange = this.handleChange.bind(this);
        this.assignDriverToUserStore = new AssignDriverToUserStore();
        this.UsersStore = new UsersStore();
        this.driverStore = new DriversStore();

        this.formRef = React.createRef();
        this.state = {
            loading: false,
            loadList: 0,
            companyId: "",
            selectedGroup: "",
            text: "",
            selectedDriver: "",
            all: false,
            assignDrivers: [],
            selectedDriversData: [],
            selectedRemove: [],
            groupId: "",
            openAssignForm: false,
            allAssignDriversArra: [],
            allUnAssignedDrivers: [],
            hideTblDta: false,
            assignAllSelectedGroup: false,
            swapCounter: 0,
            driverList: [],
            assignDriverUserId: "",
        };


    }
    onDeleteRow = async (index, driverId) => {
        if (this.state.assignAllSelectedGroup) {
            return;
        }
        const filterSelectedDriver = this.state.selectedDriver?.filter(
            (val) => val !== driverId
        );
        const filterData = this.state.assignDrivers.filter(
            (val, indexx) => indexx !== index
        );
        const filterData1 = this.state.allAssignDriversArra.filter(
            (val, indexx) => indexx !== index
        );
        console.log(filterData);
        this.setState({
            selectedDriversData: filterData1,
            assignDrivers: filterData,
            allAssignDriversArra: filterData1,
            selectedDriver: filterSelectedDriver
        });
    }
    async componentDidMount() {
        console.log(this.props);
        this.columns = [
            {
                title: this.context.translate("_DRIVER_"),
                dataIndex: "name",
            },
        ];
        this.columns1 = [
            {
                title: this.context.translate("_ASSIGNED_DRIVERS_"),
                dataIndex: "name",
                key: "driverId",
                // width: "15%",
            },
            {
                // title: "Remove",
                title: this.context.translate("_REMOVE_"),
                dataIndex: "action",
                render: (text, record, index) => {
                    // console.log(record, index);
                    return (
                        <>
                            <Space>
                                <Tooltip
                                    // title="Remove"
                                    title={this.context.translate("_REMOVE_")}
                                    color={config.tooltipColorDelete}
                                >
                                    <Link
                                        onClick={async () => {
                                            await this.onDeleteRow(index, Number(record.driverId));
                                            console.log(record, text);
                                        }}
                                    >
                                        {" "}
                                        <DeleteFilled style={{ color: config.deleteColor }} />
                                    </Link>
                                </Tooltip>
                            </Space>
                        </>
                    );
                },
            },
        ];

        const data = await this.assignDriverToUserStore.getDriveGroup({
            companyId: this.props.companyId,
        });

        const res = await this.assignDriverToUserStore.getAllUserDrivers({
            companyId: this.props.companyId,
            userId: this.props.userId,
        });
        console.log(res.driverIds);
        if (res.driverIds.length > 0) {
            if (res.groups.length > 0 && res.groups[0].drgId) {
                await this.getGroupofDrivers(res.groups[0]);
                this.formRef.current.setFieldsValue({ drgId: res.groups[0].drgId });

            } else {
                await this.driverStore.toGetDriverName(this.props.companyId);
                await this.setState({
                    driverList: this.driverStore?.getDriverName
                })
            }
            const assignedDrivers = this.assignDriverToUserStore.assignedDriverList || [];

            if (assignedDrivers.length > 0) {
                console.log(assignedDrivers)

                await this.setState({
                    allAssignDriversArra: assignedDrivers,
                    selectedDriversData: assignedDrivers,
                    selectedDriver: assignedDrivers.map((item) =>
                        Number(item.driverId)
                    ),
                    assignDrivers: assignedDrivers.map((item) =>
                        Number(item.driverId)
                    ),
                })

            }

        }
        else {
            await this.driverStore.toGetDriverName(this.props.companyId);
            await this.setState({
                driverList: this.driverStore?.getDriverName
            })
        }

        this.setState({ update: 1 })
    }


    async getGroupofDrivers(dta) {
        const data = await this.assignDriverToUserStore.getGroupofDrivers({
            drgId: dta.drgId,
            companyId: this.props.companyId,
        });

        this.setState({
            driverList: this.assignDriverToUserStore.driverList,

        })


    }
    searchInput = (e) => {
        this.setState({ text: e.target.value });


    };

    handleRemoveSelected = async (selectedRowKeys) => {
        if (this.state.assignAllSelectedGroup) {
            return;
        }
        let filteredX = this.state.selectedDriver?.filter((element) => {
            if (!this.state.selectedRemove?.includes(element)) return element;
        });

        this.setState({ selectedDriver: filteredX });

        let arr = [];
        this.state.allAssignDriversArra.forEach((val) => {
            if (!this.state.selectedRemove.includes(val.driverId)) {
                arr.push(val);
            }
        });
        this.setState({ selectedDriversData: arr, allAssignDriversArra: arr });
    };

    handleRemoveAll = async () => {
        if (this.state.assignAllSelectedGroup) {
            return;
        }
        this.setState({ selectedDriver: [], selectedDriversData: [], allAssignDriversArra: [] });
    };

    onAssignDriverToUser = async (values) => {
        this.setState({ loading: true });
        console.log(values, this.state.selectedDriver, this.props.userId);
        const data = {
            drgId: values.drgId,
            driverId: this.state.selectedDriver,
            userId: this.props.userId,
            companyId: this.props.companyId
        }
        const response = await this.assignDriverToUserStore.toAssignDriverToUser(data);
        this.setState({ loading: false });
        await this.context.viewStateStore.setUserAddStates({
            companyId: this.props.companyId,
        });
        await this.props.response(response);

    }
    closeModal = () => {
        this.props.closeModalAssignDriver();
    };
    getAllDrivers = async () => {
        await this.driverStore.toGetDriverName(this.props.companyId);
        await this.setState({
            driverList: this.driverStore?.getDriverName
        })
    }
    render() {
        return (
            <div style={{ padding: 0 }}>
                <div style={{ paddingBottom: "10px" }}>
                    <Form
                        style={{ maxWidth: "100%" }}
                        ref={this.formRef}
                        layout="vertical"
                        onFinish={this.onAssignDriverToUser}
                        {...this.layout}
                        name="nest-message"
                        className="formClass"
                    >
                        <Row className="overflowFormInputs">
                            <Col span={24} className="formColumnClass">
                                <Form.Item
                                    name="drgId"
                                    value={this.state.drgId}

                                    label={this.context.translate(
                                        "_DRIVER_GROUPS_"
                                    )}
                                    className="search-field"
                                >
                                    <Select
                                        allowClear
                                        // mode="multiple"
                                        dropdownStyle={{ overflowY: "auto" }}
                                        maxTagCount="responsive"
                                        fieldNames={{ label: "groupName", value: "drgId" }}
                                        placeholder={this.context.translate(
                                            "_DRIVER_GROUPS_"
                                        )}
                                        optionFilterProp="children"
                                        options={this.assignDriverToUserStore?.driverGroupDrivers}
                                        value={this.state.selectedGroup}
                                        onChange={async (value, option) => {

                                            if (!value) {
                                                await this.setState({
                                                    selectedGroup: undefined,
                                                    drgId: undefined,
                                                    allAssignDriversArra: [],
                                                    selectedDriversData: [],
                                                    selectedDriver: [],
                                                    assignDrivers: []
                                                });
                                                await this.getAllDrivers();

                                                return;
                                            }

                                            await this.getGroupofDrivers(option);

                                            await this.setState({
                                                selectedGroup: value,
                                                allAssignDriversArra: [],
                                                selectedDriversData: [],
                                                selectedDriver: [],
                                                assignDrivers: []
                                            });

                                            console.log(value);
                                        }}
                                    />
                                </Form.Item>

                                <Form.Item
                                    name=""
                                    // label="Search Vehicle"
                                    label={this.context.translate("_SEARCH_DRIVER_")}
                                >
                                    <Input
                                        onChange={async (e) => {
                                            await this.setState({ text: e.target.value });
                                            // await this.searchInput(e);
                                            console.log(e.target.value);
                                        }}
                                    />
                                </Form.Item>
                                <br></br>
                                <Row>
                                    <Col span={11}>
                                        <Table
                                            // style={{height:300}}
                                            scroll={{
                                                x: 240,
                                                y: 300,
                                            }}
                                            pagination={false}
                                            bordered
                                            rowKey="driverId"
                                            columns={this.columns}
                                            rowSelection={{
                                                selectedRowKeys: this.state.selectedDriver,
                                                onChange: async (selectedRowKeys, selectedRows) => {

                                                    if (this.state.assignAllSelectedGroup) {
                                                        return;
                                                    }

                                                    let finalSelectedDrivers = [...this.state.allAssignDriversArra];

                                                    selectedRows.forEach((row) => {
                                                        const exists = finalSelectedDrivers.find(
                                                            (item) => Number(item.driverId) === Number(row.driverId)
                                                        );

                                                        if (!exists) {
                                                            finalSelectedDrivers.push(row);
                                                        }
                                                    });

                                                    finalSelectedDrivers = finalSelectedDrivers.filter((item) =>
                                                        selectedRowKeys.includes(Number(item.driverId))
                                                    );

                                                    await this.setState({
                                                        selectedDriver: finalSelectedDrivers.map((item) =>
                                                            Number(item.driverId)
                                                        ),
                                                        assignDrivers: finalSelectedDrivers.map((item) =>
                                                            Number(item.driverId)
                                                        ),
                                                        selectedDriversData: finalSelectedDrivers,
                                                        allAssignDriversArra: finalSelectedDrivers,
                                                    });
                                                }
                                                // selectedRowKeys: this.state.assignDrivers,
                                            }}
                                            dataSource={
                                                (this.state.driverList || []).map((item) => ({
                                                    ...item,
                                                    driverId: Number(item.driverId),
                                                })).filter((item) => {

                                                    const search = (this.state.text || "")
                                                        .toLowerCase()
                                                        .replace(/\s+/g, "");

                                                    const driverName = (item.name || "")
                                                        .toLowerCase()
                                                        .replace(/\s+/g, "");

                                                    return driverName.includes(search);
                                                })
                                            }
                                        />
                                    </Col>
                                    <Col span={2}></Col>
                                    <Col span={11}>
                                        <Table
                                            scroll={{
                                                x: 240,
                                                y: 300,
                                            }}
                                            pagination={false}
                                            bordered
                                            rowSelection={{
                                                selectedRowKeys: this.state.selectedRowKeys?.map(
                                                    (val) => {
                                                        return val.driverId;
                                                    }
                                                ),
                                                onChange: async (selectedRowKeys, selectedRows) => {
                                                    console.log(selectedRowKeys);
                                                    this.setState({ selectedRemove: selectedRowKeys });
                                                },
                                            }}
                                            // total={this.UsersStore?.total}
                                            rowKey="driverId"
                                            columns={this.columns1}
                                            dataSource={
                                                // this.driverStore?.getDriverName
                                                this.state.allAssignDriversArra
                                                // ? this.state.allAssignDriversArra
                                                // : this.state.selectedDriversData
                                            }
                                        />
                                    </Col>
                                </Row>
                            </Col>
                        </Row>

                        {/* <div className="formFooter">
                            <Button
                                className="formsCancelButton"
                                onClick={() => this.closeModal()}
                            >
                                {this.context.translate("_FLEET_DASHBORD_ROUTEADD_CANCELBTN_")}
                            </Button>

                            <Button
                                disabled={this.state.assignAllSelectedGroup}
                                type="primary"
                                className="formSaveButton"
                                onClick={this.handleRemoveSelected}
                            >
                                
                                {this.context.translate("_REMOVE_")}
                            </Button>
                            <Button
                                disabled={this.state.assignAllSelectedGroup}
                                type="primary"
                                style={{ width: "113px" }}
                                className="formSaveButton"
                                onClick={this.handleRemoveAll}
                            >
                              
                                {this.context.translate("_REMOVE_ALL_")}
                            </Button>

                            <Button
                                loading={this.state.loading}
                                type="primary"
                                htmlType="submit"
                                className="formSaveButton"
                            >
                               
                                {this.context.translate("_FLEET_DASHBORD_NEWPOI_SAVEBTN_")}
                            </Button>
                        </div> */}
                        <div className="formFooter">
                            <Button
                                className="formsCancelButton"
                                onClick={() => this.closeModal()}
                            >
                                {this.context.translate("_FLEET_DASHBORD_ROUTEADD_CANCELBTN_")}
                            </Button>

                            <Button
                                disabled={this.state.assignAllSelectedGroup}
                                className="formsSaveButton"
                                onClick={this.handleRemoveSelected}
                            >
                                {this.context.translate("_REMOVE_")}
                            </Button>
                            <Button
                                style={{ marginInlineStart: "0px" }}
                                disabled={this.state.assignAllSelectedGroup}
                                className="formsSaveButton"
                                onClick={this.handleRemoveAll}
                            >
                                {this.context.translate("_REMOVE_ALL_")}
                            </Button>

                            <Button
                                style={{ marginInlineStart: "0px" }}
                                loading={this.state.loading}
                                htmlType="submit"
                                className="formsSaveButton"
                            >
                                {this.context.translate("_FLEET_DASHBORD_NEWPOI_SAVEBTN_")}
                            </Button>
                        </div>
                    </Form>
                </div>
            </div>
        );
    }
}

AssignDriverToUser.contextType = StoreContext;
export default observer(withRouter(AssignDriverToUser));
